import { planAutoHN } from '../../../utils/planes'

const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = true;

const InitPage: number = 0;
const TotalPage: number = 4;

const AutoDataTemp: IAutoHN = {
    init: false,
    identificationType: '',
    identification: '',
    firstName1: '',
    firstName2: '',
    lastName1: '',
    lastName2: '',
    phoneNumber: '',
    mail: '',
    //gender: '',
    civilStatus: '',
    //economicActivity: '',
    vehicleUse: '',
    vehicleStatus: '',
    vehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',
    vehicleColor: '',
    vehicleChassis: '',
    vehicleValue: '',
    vehicleType: 0,
    paymentFrequency: '',
    acceptTerms: false,
    idPlan: planAutoHN,
    saved: false,
    error:false,
    isDatasheet: false,
    policyNumber: 0,
    opportunitySent: false,

    catVehicleBrand: [],
    catVehicleUse: [],
    catVehicleModel: [],
    catVehicleYear: [],
    catPaymentFrequency: [{text: "Anual (1 cuota)", value: "1", description: "A"},{text: "Bimensual (6 cuotas)", value: "6", description: "B"},{text: "8 Cuotas", value: "8", description: "M"}],

    coveragesPlan: {} as ICoveragesPlan,
    datasheet: {} as IDataheet,
    planConfig: {} as IPlanConfig,

    rates:[],
    summary: {} as IRatesResumen,

    OA_EquipoEspecial: {Tipo:1,Valor:'',Observaciones:''} as OA_EquipoEspecial
}

const AutoDataTempWithData: IAutoHN = {
    init: false,
    identificationType: '1',
    identification: '0001-1708-00023',
    firstName1: 'Engell',
    firstName2: 'Eduardo',
    lastName1: 'Lopez',
    lastName2: 'Mairena',
    phoneNumber: '8888-8888',
    mail: 'elopezm@lafise.com',
    //gender: '1',
    civilStatus: '1',
    //economicActivity: '1',
    vehicleUse: '1',
    vehicleStatus: '1',
    vehicleBrand: '',
    vehicleModel: '',
    vehicleYear: '',
    vehicleColor: 'Blanco',
    vehicleChassis: 'MK202020',
    vehicleValue: '100000',
    vehicleType:0,
    paymentFrequency: '1',
    acceptTerms: true,
    idPlan: planAutoHN,
    saved: false,
    error:false,
    isDatasheet: false,
    policyNumber: 0,
    opportunitySent: false,


    catVehicleBrand: [],
    catVehicleUse: [],
    catVehicleModel: [],
    catVehicleYear: [],
    catPaymentFrequency: [],

    coveragesPlan: {} as ICoveragesPlan,
    datasheet: {} as IDataheet,
    planConfig: {} as IPlanConfig,

    rates:[],
    summary: {} as IRatesResumen,

    OA_EquipoEspecial: {Tipo:1,Valor:'1600',Observaciones:'Radio Sony'} as OA_EquipoEspecial
}

const setObj = () => (setData && isDevelopment) ? ({ ...AutoDataTempWithData }) : ({ ...AutoDataTemp });

const AutoHNDefault: IAutoHN = setObj();

export { AutoHNDefault, InitPage, TotalPage };